"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lookupRecord = lookupRecord;

function lookupRecord(record, key) {
  const value = record[key];
  return !!value;
}
//# sourceMappingURL=helpers.js.map